import { render, staticRenderFns } from "./IconStopSale.vue?vue&type=template&id=0c4e2134&"
import script from "./IconStopSale.vue?vue&type=script&lang=ts&"
export * from "./IconStopSale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports